@import './pk-sequence.variables';

.pk-sequence__heading {
  ::slotted(*) {
    @apply m-0 p-0 font-bold text-l leading-l text-[color:--sequence--title-color];
  }
}

.hidden {
  @include hidden;
}
